/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactMethodType/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ContactMethodType({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/ContactMethodType"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let constantData = 'email'
let treatmentPlanRequestContactMethodTypeValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan_request',
path: 'contact_method_type',
})
let aggregateData = fromAggregate.equals(constantData, treatmentPlanRequestContactMethodTypeValueData)
let onClick = fromHelpers.useOnChangeEmail({
  children,
  viewPath
  
})
let constantData1 = 'phone'
let treatmentPlanRequestContactMethodTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'treatment_plan_request',
path: 'contact_method_type',
})
let aggregateData1 = fromAggregate.equals(constantData1, treatmentPlanRequestContactMethodTypeValueData1)
let onClick1 = fromHelpers.useOnChangePhone({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="ContactMethodType.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Send to"
/>
<div
  data-testid="ContactMethodType.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z4C412': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ContactMethodType.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 text="Email"
 data="'email'"
 data="treatment_plan_request.contact_method_type"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
/>
</div>
<div
  data-testid="ContactMethodType.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 text="Phone"
 data="'phone'"
 data="treatment_plan_request.contact_method_type"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 onClick={onClick1}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}